// utils/compressImage.js
import imageCompression from 'browser-image-compression';

/**
 * Compress a single image file
 * @param {File} file - Original image file (from <input type="file"/> or drag & drop)
 * @param {Object} customOptions - Optional compression settings
 * @returns {Promise<File>} - Compressed image file
 */
export const compressImage = async (file, customOptions = {}) => {
    if (!file) throw new Error("No file provided");

    const defaultOptions = {
        maxSizeMB: 1,           // Target maximum size in MB
        maxWidthOrHeight: 1920, // Max dimension (resize if larger)
        useWebWorker: true,     // Offload to web worker for performance
    };

    const options = { ...defaultOptions, ...customOptions };

    try {
        const compressedFile = await imageCompression(file, options);
        return compressedFile;
    } catch (err) {
        console.error("Image compression failed:", err);
        return file; // Return original if compression fails
    }
};

/**
 * Compress multiple images
 * @param {File[]} files - Array of image files
 * @param {Object} customOptions - Optional compression settings
 * @param {Function} onProgress - Optional callback(progress, index, total)
 * @returns {Promise<File[]>} - Array of compressed image files
 */
export const compressImages = async (files, customOptions = {}, onProgress) => {
    const compressedFiles = [];

    for (let i = 0; i < files.length; i++) {
        const compressed = await compressImage(files[i], customOptions);
        compressedFiles.push(compressed);

        if (onProgress) {
            const percent = Math.round(((i + 1) / files.length) * 100);
            onProgress(percent, i + 1, files.length);
        }
    }

    return compressedFiles;
};


// import React, { useState } from "react";
// import { compressImage, compressImages } from "./utils/compressImage";

// export default function DemoCompressor() {
//     const [file, setFile] = useState(null);
//     const [compressed, setCompressed] = useState(null);

//     const handleSingle = async (e) => {
//         const f = e.target.files[0];
//         setFile(f);

//         const compressedFile = await compressImage(f, { maxSizeMB: 0.5 });
//         setCompressed(compressedFile);
//     };

//     const handleMultiple = async (e) => {
//         const files = Array.from(e.target.files);

//         const compressedList = await compressImages(files, { maxSizeMB: 0.7 }, (progress, idx, total) => {
//             console.log(`Progress: ${progress}% (${idx}/${total})`);
//         });

//     };

//     return (
//         <div>
//             <h3>Single Image</h3>
//             <input type="file" accept="image/*" onChange={handleSingle} />
//             {compressed && (
//                 <div>
//                     <p>Original: {(file.size / 1024).toFixed(2)} KB</p>
//                     <p>Compressed: {(compressed.size / 1024).toFixed(2)} KB</p>
//                     <img src={URL.createObjectURL(compressed)} alt="preview" width={200} />
//                 </div>
//             )}

//             <h3>Multiple Images</h3>
//             <input type="file" accept="image/*" multiple onChange={handleMultiple} />
//         </div>
//     );
// }
